import React from 'react';
import './input-custom.css';
import { ShopCategoriesType } from '../../../types/shopCategories';

interface ActionsColumnProps {
  record: ShopCategoriesType;
  onChangeInput: Function;
  submitInput: Function;
  loading?: boolean;
  onFocusNewRow: Function;
}

export const InputLink = (props: ActionsColumnProps) => {
  const { record, onChangeInput, submitInput, loading, onFocusNewRow } = props;
  const url = record?.ctaLink || '';
  const title = record?.title || '';
  const isBlock = false;

  return (
    <div className="add-link-container">
      <input
        type="text"
        placeholder="URL"
        value={url}
        onChange={event => {
          onChangeInput(event);
        }}
        name="ctaLink"
        disabled={isBlock}
        className="link-url-input"
        onFocus={event => {
          if (!record?.id && !record?.title && !record?.ctaLink) {
            onFocusNewRow(event);
          }
        }}
        draggable
        onDragStart={event => event.preventDefault()}
      />
      {url && title && (
        <button type="button" disabled={loading} onClick={() => submitInput()} className="add-link-button">
          {record?.id ? 'UPDATE LINK' : 'ADD LINK'}
        </button>
      )}
    </div>
  );
};
